module.exports = __webpack_public_path__ + "static/media/icon-domicilio.3617d27c.svg";